module.exports = __webpack_public_path__ + "cv.svg?383ab6208681e8dfd9721c0ab602cd72";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/cv.svg
// module id = 1034
// module chunks = 27